module.exports = __webpack_public_path__ + "img/SES_500420011.cc43de2a.jpg";